import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { CamTranslationGrid } from '../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-bool-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `{{ (this.value === true ? 'grid.common.true' : 'grid.common.false') | translate }}`,
  imports: [TranslatePipe],
})
export class GridBoolCellComponent extends AbstractCellComponent<any, boolean> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
}
